export default __webpack_public_path__ + "static/media/paste.ca0e64d6.svg";